import { SelectButton } from 'primereact/selectbutton';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateUser } from '../../store/actions/proyectAction';

const ActualizarRol = ({ currentUser, updateUser, t, toast }) => {
  const roles = ['Administrador', 'Cliente', 'Tecnico'];
  const updateUserRole = async rol => {
    try {
      await updateUser({
        ...currentUser,
        rol: rol.toLowerCase(),
      });
      toast?.current?.show({
        severity: 'info',
        summary: t('Confirmed'),
        detail: t('Rol de usuario actualizado'),
        life: 3000,
      });
    } catch (e) {
      toast?.current?.show({
        severity: 'error',
        summary: t('Rejected'),
        detail: t('Rol de usuario no actualizado'),
        life: 3000,
      });
    }
  };

  return (
    <div className="p-col-12 p-md-12 floatLeft margin5">
      <h3
        className="floatLeft margingtop10 p-col-12"
        style={{ marginBottom: '8px' }}
      >
        {t('Rol Actual Usuario')}: {currentUser?.nombre}
      </h3>
      <SelectButton
        className="p-col-12"
        value={
          currentUser?.rol?.charAt(0)?.toUpperCase() +
          currentUser?.rol?.slice(1)
        }
        options={roles}
        onChange={e => updateUserRole(e.value)}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateUser,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(ActualizarRol);
